export const getExtension = (name: string): string => {
  const strToArr = name.split(".");

  if (strToArr.length < 2) {
    return "";
  }

  return strToArr.at(-1)?.toLowerCase() ?? "";
};
